const useNaverGfa = () => {
  const sendNaverGfaConversion = (type: string, value: string) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _nasa: { cnv?: any } = {};
    if (!window.wcs) return;
    _nasa["cnv"] = window.wcs.cnv(type, value);
  };

  return { sendNaverGfaConversion };
};

export default useNaverGfa;
